import AuthAPI from "./auth.js";
const Auth = new AuthAPI();

// Public
export function getQuestions(notarizationId, signerId) {
	return Auth.GET(url(notarizationId, signerId));
}

export function submitAnswers(notarizationId, signerId, answers) {
	return Auth.POST(url(notarizationId, signerId), answers);
}

export function getChallengeQuestions(notarizationId, signerId) {
	return Auth.GET(`${url(notarizationId, signerId)}/challenge`);
}

// Private
function url(notarizationId, signerId) {
	return `/Notarization/${notarizationId}/Signers/${signerId}/KBA`;
}